import React, { useState, useCallback, useMemo, useEffect } from "react"

export const Answer = ({
  text,
  voteValue,
  showResult,
  isSelected,
  isLeading,
  onClick,
  voteStyle = "warning", // danger, success, info see bootstrap
}) => {
  return (
    <li
      onClick={onClick}
      className={`progress poll-answer ${
        showResult ? "poll-answer-result" : ""
      }`}
    >
      <div
        className={`progress-bar progress-bar-${voteStyle} poll-vote-layer`}
        style={{ width: `${!showResult ? 0 : voteValue || 0}%` }}
      />
      {showResult && (
        <div
          className={`poll-answer-vote-percentage pull-right ${
            isLeading ? "text-lg" : ""
          }`}
        >
          {voteValue} %
        </div>
      )}
      <div className="poll-answer-text">
        {text} {isSelected && <span className="mbicon mbicon-check" />}
      </div>
    </li>
  )
}

export const Poll = React.forwardRef(
  ({ answers, selected, onVote, AnswerComponent = Answer }, ref) => {
    // if user clicks a answer, show the results and bubble up
    // also only trigger if not already clicked.
    const doVote = useCallback(
      id => {
        !selected && onVote(id)
      },
      [onVote, selected]
    )

    const [highestVoteId] = useMemo(
      () =>
        answers.reduce(
          ([curId, curVal], { id, voteValue }) => {
            if (voteValue > curVal) {
              ;[curId, curVal] = [id, voteValue]
            }
            return [curId, curVal]
          },
          [0, 0]
        ),
      [answers, selected]
    )

    return (
      <ul className="poll" ref={ref}>
        {answers.map(({ id, answer: text, voteValue }) => (
          <AnswerComponent
            id={id}
            key={id}
            text={text || id}
            onClick={() => doVote(id)}
            showResult={!!selected}
            isSelected={selected === id}
            isLeading={highestVoteId === id}
            voteValue={voteValue}
          />
        ))}
      </ul>
    )
  }
)
